import { FundType } from "./common.model";
import { Fee } from "./fee.model";
import { Obj } from "./types";

/** One per-PSP "Paid On" override rule. `id` is absent for rows the user just added. */
export interface PaidOnOverrideRule {
    id?: number;
    psp_code: string;
    paid_on: string;
}

export class DisbursementConfig {
    channel?: string;
    currency?: string;
    extra?: string;
    fee_deducted_by?: string;
    first_payout_at?: string;
    fund_type?: FundType;
    label?: string;
    fee?: Fee;
    minimum_fund?: string;
    paid_on?: string;
    timing?: string;

    constructor({
        channel,
        currency,
        extra,
        fee_deducted_by,
        first_payout_at,
        fund_type,
        label,
        fee,
        minimum_fund,
        paid_on,
        timing,
      }: Obj) {
        if (channel !== undefined) this.channel = channel;
        if (currency !== undefined) this.currency = currency;
        if (extra !== undefined) this.extra = extra;
        if (fee_deducted_by !== undefined) this.fee_deducted_by = fee_deducted_by;
        if (first_payout_at !== undefined) this.first_payout_at = first_payout_at;
        if (fund_type !== undefined) this.fund_type = fund_type;
        if (label !== undefined) this.label = label;
        if (fee !== undefined) this.fee = new Fee({}).fromPayload(fee);
        if (minimum_fund !== undefined) this.minimum_fund = minimum_fund;
        if (paid_on !== undefined) this.paid_on = paid_on;
        if (timing !== undefined) this.timing = timing;
    }

    fromPayload({
        channel,
        currency,
        extra,
        fee_deducted_by,
        first_payout_at,
        fund_type,
        label,
        fee,
        minimum_fund,
        paid_on,
        timing,
      }: Obj) {
        if (channel !== undefined) this.channel = channel;
        if (currency !== undefined) this.currency = currency;
        if (extra !== undefined) this.extra = extra;
        if (fee_deducted_by !== undefined) this.fee_deducted_by = fee_deducted_by;
        if (first_payout_at !== undefined) this.first_payout_at = first_payout_at;
        if (fund_type !== undefined) this.fund_type = fund_type;
        if (label !== undefined) this.label = label;
        if (fee !== undefined) this.fee = new Fee({}).fromPayload(fee);
        if (minimum_fund !== undefined) this.minimum_fund = minimum_fund;
        if (paid_on !== undefined) this.paid_on = paid_on;
        if (timing !== undefined) this.timing = timing;
        return this;
    }
}